import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme:{
        themes:{
            light:{
                primary:'#0089E1',
                secondary:'#4fb2a9',
                danger: '#DC3545',
            }
        }
    }
});
